import { FormFieldBase } from './form-field-base';

export class HtmlAreaField extends FormFieldBase<string> {
    override controlType = 'html';
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}